import React from 'react'

import IconButton from '@material-ui/core/IconButton'
import InputAdornment from '@material-ui/core/InputAdornment'
import { withStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import IconClearText from '@material-ui/icons/Close'
import IconSearch from '@material-ui/icons/Room'
import get from 'lodash/get'
import isNil from 'lodash/isNil'
import toLower from 'lodash/toLower'
import Feature from 'ol/Feature'
import Point from 'ol/geom/Point'
import { Vector as VectorLayer } from 'ol/layer'
import VectorSource from 'ol/source/Vector'
import { Icon, Style } from 'ol/style'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, setDirectionsEndLocation } from 'api/actions'
import * as Model from 'api/model'
import GetAddressFromHereMaps from 'data/GetAddressFromHereMaps'
import GetLocationLabel from 'drawer/tabs/search/panels/GetLocationLabel'
import ShowRoute from 'drawer/tabs/search/panels/ShowRoute'
import PoziMap from 'map/map'

const KEYCODE_ENTER = 13 // https://www.javascriptkeycode.com/

const styles = theme => ({
  root: { },
  header: {},
  iconSearch: {
    color: '#757575'
  },
  textField: {
    background: 'white',
    width: '100%',
    marginLeft: 0,
    marginRight: 0,
    marginBottom: 8
  }
})

class SearchPanelDirectionsEnd extends React.Component {
  constructor (props) {
    super(props)

    this.pure = {}
    this.pure.handleChange = this.handleChange.bind(this)
    this.pure.addornment = this.buildSearchBoxAddornment()

    const styles = {
      startMarker: new Style({
        image: new Icon({
          src: 'img/custom/select_marker_directions_end.png'
        })
      })
    }

    this.pure.olLayerMarker = new VectorLayer({
      zIndex: 1000,
      source: new VectorSource({
        features: []
      }),
      style: function (feature) {
        return styles[feature.get('type')]
      }
    })

    PoziMap().addLayer(this.pure.olLayerMarker)
    const fc = Model.get('app.map.target.featurecollection', null)
    const type = toLower(get(fc, 'features[0].geometry.type', ''))

    if (type === 'point') {
      const coords = get(fc, 'features[0].geometry.coordinates', null)
      if (!isNil(coords)) {
        this.props.setDirectionsEndLocation(coords)
      }
    }
  }

  updateMarkerLocation () {
    const { endLocation } = this.props
    const coords = get(endLocation, 'coords', [])
    this.pure.olLayerMarker.getSource().clear()
    if (coords.length === 2) {
      const startLocation3857 = window.appObject.transformFrom4326(coords)
      const startMarker = new Feature({
        type: 'startMarker',
        geometry: new Point(startLocation3857)
      })
      this.pure.olLayerMarker.getSource().addFeature(startMarker)
    }
  }

  update () {
    const { endLocation, setDirectionsEndLocation } = this.props

    console.log('Update directions end location')

    this.updateMarkerLocation()
    ShowRoute()

    const coords = get(endLocation, 'coords', {})
    const lng = get(coords, '[0]', null)
    const lat = get(coords, '[1]', null)
    if (isNil(lng) || isNil(lat)) {
      console.log('Invalid coordinates... unable to get lng/lat.', lng, lat)
      return
    }

    GetAddressFromHereMaps().getGeoJSONFromLngLat(lng, lat).then(function (geojson) {
      console.log('GetAddressFromHereMaps', geojson)
      setDirectionsEndLocation(coords, geojson)
    }).catch(function (err) {
      console.log('Unable to reverse geocode start location coords.', err)
    })
  }

  componentWillUnmount () {
    this.pure.olLayerMarker.getSource().clear()
  }

  componentDidMount () {
    this.update()
  }

  handleChange (event) {
    console.log('Do not set location to a string, it is [lng,lat]')
  }

  clearSearch () {
    this.props.setDirectionsEndLocation([])
  }

  // https://github.com/mui-org/material-ui/pull/16672
  handleMouseDownPassword (event) {
    event.preventDefault()
  }

  buildSearchBoxAddornment () {
    const { classes } = this.props
    return {
      inputProps: {
        'data-lpignore': 'true'
      },
      startAdornment: (
        <InputAdornment position="start">
          <IconSearch className={classes.iconSearch} />
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          <IconButton edge="end" size="small" aria-label="clear search" onClick={this.clearSearch.bind(this)} onMouseDown={this.handleMouseDownPassword}>
            <IconClearText className={classes.iconClearText} />
          </IconButton>
        </InputAdornment>
      ),
      onKeyDown: (e) => {
        if (e.keyCode === KEYCODE_ENTER) {
          console.log('Ignore enter event.')
          return false // Do not propagate the enter event.
        }
      }
    }
  }

  componentDidUpdate (prevProps) {
    const locationOld = get(prevProps, 'endLocation', null)
    const locationNew = get(this.props, 'endLocation', null)
    const coordsOldLng = get(locationOld, 'coords[0]', null)
    const coordsOldLat = get(locationOld, 'coords[1]', null)
    const coordsNewLng = get(locationNew, 'coords[0]', null)
    const coordsNewLat = get(locationNew, 'coords[1]', null)

    if (coordsOldLng !== coordsNewLng && coordsOldLat !== coordsNewLat) {
      this.update()
    }
  }

  render () {
    const { classes, endLocation, expanded } = this.props

    if (!expanded) {
      return null
    }

    const textFieldValue = GetLocationLabel(endLocation)

    const textField = (
      <form noValidate autoComplete="off">
        <TextField
          id="tab-search-directions-end"
          name="tab-search-directions-end"
          placeholder="Click the map to set destination"
          label=""
          autoComplete="off"
          spellCheck="false"
          margin={'dense'}
          className={classes.textField}
          value={textFieldValue}
          onChange={this.pure.handleChange}
          variant="outlined"
          InputProps={this.pure.addornment}
        />
      </form>
    )

    return (
      <div className={classes.root}>
        {textField}
      </div>
    )
  }
}

SearchPanelDirectionsEnd.propTypes = {
  classes: PropTypes.object.isRequired,
  setDirectionsEndLocation: PropTypes.func.isRequired,
  endLocation: PropTypes.object.isRequired,
  expanded: PropTypes.bool.isRequired
}

function mapStateToProps (state, ownProps) {
  const endLocation = get(state.config, LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_END_LOCATION, {})
  const expanded = get(state, 'config.' + LAYOUT_DRAWER_TABS_SEARCH_PANELS_DIRECTIONS_EXPANDED, true)
  return {
    endLocation,
    expanded
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDirectionsEndLocation: (endLocation, geojson) => {
      dispatch(setDirectionsEndLocation(endLocation, geojson))
    }
  }
}

export default (
  withStyles(styles)(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SearchPanelDirectionsEnd)
  )
)
